export default {
  defaultLocale: 'en-us',
  allowLocales: [
    { name: '繁體中文', code: 'zh-tw' },
    { name: 'English', code: 'en-us' },
  ],
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/configs/locale.js
 **/